;(function(jQuery){

	"use strict";

	function Cards()
	{
		var global = {
			desktopColumnCount: 3,
			cards: false
		};

		var fn = {
			init: function()
			{
				fn.setupCards();
			},

			setupCards: function()
			{
				var cardGrids = jQuery('.cards__grid');

				if (!cardGrids.length)
				{
					return;
				}

				var windowWidth = jQuery(window).width();
				if (windowWidth < 1024)
				{
					return; // don't equalise heights on mobile
				}

				cardGrids.each(function(i, cardGrid) {
					global.cards = jQuery(cardGrid).find('.card');
					fn.handleCardRows(global.desktopColumnCount);
				});

			},

			handleCardRows: function(columnCount)
			{
				var cardRow = [];

				global.cards.each(function(i, card) {
					cardRow.push(card);
					if ((i + 1) % columnCount === 0 || (i + 1) == global.cards.length)
					{
						fn.equaliseHeights(cardRow);
						cardRow = []; // empty the array for next row
					}
				});
			},

			equaliseHeights: function(row)
			{
				var headings = jQuery(row).find('.card__heading');
				var teasers = jQuery(row).find('.card__teaser');
				var elementGroups = [headings, teasers];

				jQuery(elementGroups).each(function(i, elementGroup) {
					var largestElement = fn.getLargestHeight(elementGroup);

					elementGroup.each(function(i, element) {
						jQuery(element).css('min-height', largestElement);
					});
				});
			},

			getLargestHeight: function(elems)
			{
				var largest = 0;
				elems.each(function(i, elem) {
					var elemHeight = jQuery(elem).height();
					if (elemHeight > largest)
					{
						largest = elemHeight;
					}
				});

				return largest;
			}
		}

		jQuery(fn.init);
	}

	new Cards();
})(jQuery);